// extracted by mini-css-extract-plugin
export default {"card":"card_card__HSFcX","card__content":"card_card__content__g7-EO","card__content--standalone":"card_card__content--standalone__He-tn"};